import {recipeTranslation} from '../recipes/recipe.js';
import {createCraftRecipePlan,createCraftSessionSnapshot,createCraftProcessSnapshot,CraftSessionPhase} from '../craft/contracts.js';
import {createRecipePlan,recipeToJournalDraft} from '../recipes/recipe-process.js';
import {duplicateCompletedSessionPlan} from '../history/repeat-session.js';
import {compareRepeatToSource} from '../history/repeat-comparison.js';

const PHASE=Object.freeze({smoking:CraftSessionPhase.ACTIVE,draft:CraftSessionPhase.DRAFT,planned:CraftSessionPhase.PLANNED,preparation:CraftSessionPhase.PREPARATION,ready:CraftSessionPhase.READY,resting:CraftSessionPhase.RESTING,completed:CraftSessionPhase.COMPLETED,cancelled:CraftSessionPhase.CANCELLED});
function craftSession(session){return createCraftSessionSnapshot({id:session.id,phase:PHASE[session.status],title:session.title,plannedStartAt:session.plannedStartAt,plannedEndAt:session.plannedEndAt,sourceRecipeId:session.recipeId,sourceSessionId:session.sourceSessionId});}
function recipeInput(plan){return {recipe:plan.recipe,items:plan.items,preparations:plan.preparations,woods:plan.woods,stages:plan.stages,stageTargets:plan.stageTargets,stageItemTargets:plan.stageItemTargets};}

export function createDymistrzCraftAdapter(){
  return Object.freeze({
    toCraftRecipePlan(input){
      const plan=createRecipePlan(input);
      return createCraftRecipePlan({id:plan.recipe.id,title:recipeTranslation(plan.recipe,{locale:input.locale}).title,items:plan.items,stages:plan.stages,targets:[...plan.stageTargets,...plan.stageItemTargets],metadata:{version:plan.recipe.version}});
    },
    createSessionFromPlan(input){
      const plan=createRecipePlan(recipeInput(input));
      return recipeToJournalDraft(plan,input);
    },
    toCraftProcessSnapshot(bundle={}){
      return createCraftProcessSnapshot({session:craftSession(bundle.session),items:bundle.items||[],stages:bundle.stages||[],targets:[...(bundle.stageTargets||[]),...(bundle.stageItemTargets||bundle.itemTargets||[])],events:bundle.events||bundle.liveEvents||[],outcome:bundle.outcome||null});
    },
    repeatFromCompleted(input){return duplicateCompletedSessionPlan(input);},
    compareRepeat(input){return compareRepeatToSource(input);}
  });
}
